import { render, staticRenderFns } from "./m-article-media.vue?vue&type=template&id=4f9521e4&scoped=true"
import script from "./m-article-media.vue?vue&type=script&lang=js"
export * from "./m-article-media.vue?vue&type=script&lang=js"
import style0 from "./m-article-media.vue?vue&type=style&index=0&id=4f9521e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9521e4",
  null
  
)

export default component.exports